import cn from 'classnames';
import get from 'lodash/get';

import { productImageURL } from '../../utils/products';

import styles from './ProductChangesModal.module.scss';

export default function ProductTileChanged({ product, unavailable }) {
  const imgSrc = !product.isSpecialOffer
    ? productImageURL(get(product, 'images.primary', ''), 'cartTile')
    : get(product, 'image.mobileLarge', ''); // Duplicated code - find by exact match
  const price = !product.isSpecialOffer
    ? `€ ${((product.finalPrice * product.stepToUom) / 100).toFixed(2)} `
    : `€ ${(product.price / 100).toFixed(2)} `;
  return (
    <div className={cn(styles.productTile, { [styles.unavailable]: unavailable })}>
      <div className={styles.productTileImgContainer}>
        <img className={styles.productTileImg} src={imgSrc} alt={product.name} />
      </div>
      <div className={styles.mainInfo}>
        <p className={styles.info}>{product.name}</p>
        <p className={styles.extraInfo}>{product.displayDescription || product.webSticker}</p>
        <p className={styles.info}>{price}</p>
      </div>
    </div>
  );
}
